module.exports = __webpack_public_path__ + "static/logo_ca-98e3505a122cadb5d6c34d20dd0e24f2.png";